import { takeEvery, call, put, all } from "redux-saga/effects";
import { actionTypes, actions } from "./actions";
import { actions as commonActions } from "../../../store/actions";
import { createTermAPI, getPaymentTermsAPI, getTermPartnersAPI, updateTermAPI } from "./endpoints";

function* getPaymentTermsSaga(action) {
  try {
    yield put(commonActions.setLoading(true));
    const _api = yield call(getPaymentTermsAPI, action.payload);
    yield put(actions.setPaymentTerms(_api.data.results));
    yield put(commonActions.setLoading(false));
  } catch (error) {
    yield put(commonActions.setLoading(false));
    console.log(error);
  }
}

function* getPaymentPartnersSaga(action) {
  try {
    yield put(commonActions.setLoading(true));
    const _api = yield call(getTermPartnersAPI, action.payload);
    yield put(actions.setPaymentPartners(_api.data.results));
    if (_api.data.results.length === 0) {
      yield put(
        commonActions.setAlert({
          message: "There is no partners for the selected search condition",
          alertType: "info",
          showToast: true,
        })
      );
    }
    yield put(commonActions.setLoading(false));
  } catch (error) {
    yield put(commonActions.setLoading(false));
    console.log(error);
  }
}

function* createTermSaga(action) {
  try {
    yield put(commonActions.setLoading(true));
    const _api = yield call(createTermAPI, action.payload);
    if (_api?.data?.success) {
      yield put(actions.getPaymentTerms());
      yield put(
        commonActions.setAlert({
          message: "Term Saved Successfully",
          alertType: "success",
          showToast: true,
        })
      );
      yield put(actions.editFormViewStatus(false));
    }
    yield put(commonActions.setLoading(false));
  } catch (error) {
    yield put(
      commonActions.setAlert({
        message: error?.response?.data?.message || error.message || "Save Payment Term Failed",
        alertType: "error",
        showToast: true,
      })
    );
    yield put(commonActions.setLoading(false));
    console.log(error);
  }
}

function* updateTermSaga(action) {
  try {
    yield put(commonActions.setLoading(true));
    const _api = yield call(updateTermAPI, action.payload);
    if (_api?.data?.success) {
      yield put(actions.getPaymentTerms());
      yield put(
        commonActions.setAlert({
          message: "Term Updated Successfully",
          alertType: "success",
          showToast: true,
        })
      );
      yield put(actions.editFormViewStatus(false));
    }
    yield put(commonActions.setLoading(false));
  } catch (error) {
    yield put(
      commonActions.setAlert({
        message: error?.response?.data?.message || error.message || "Term Update Failed",
        alertType: "error",
        showToast: true,
      })
    );
    yield put(commonActions.setLoading(false));
    console.log(error);
  }
}

export function* withPaymentTermsSaga() {
  yield all([
    takeEvery(actionTypes.GET_PAYMENT_TERMS, getPaymentTermsSaga),
    takeEvery(actionTypes.GET_PAYMENT_PARTNERS, getPaymentPartnersSaga),
    takeEvery(actionTypes.CREATE_TERM, createTermSaga),
    takeEvery(actionTypes.UPDATE_TERM, updateTermSaga),
  ]);
}
